<script setup>
import AppLayout from "@/Layouts/AppLayout.vue";
import FormSection from "@/Components/FormSection.vue";
import PrimaryButton from "@/Components/PrimaryButton.vue";
import SecondaryButton from "@/Components/SecondaryButton.vue";
import InputLabel from "@/Components/InputLabel.vue";
import TextInput from "@/Components/TextInput.vue";
import SelectInput from "@/Components/SelectInput.vue";
import { useForm } from "@inertiajs/inertia-vue3";

const props = defineProps({
  tax: Object,
  readOnly: { type: Boolean, default: false }
})

const form = useForm({
  _method: props.tax?.tax_id ? "PUT" : "POST",
  tax_name: props.tax?.tax_name || "",
  tax_amount: props.tax?.tax_amount ?? 0,
  status: props.tax?.status ?? 1,
})

const saveForm = () => {
  const isEdit = !!props.tax?.tax_id
  const routeName = isEdit
    ? route("admin.tax.update", { tax: props.tax.tax_id })
    : route("admin.tax.store")

  form.post(routeName, {
    preserveScroll: true,
    onSuccess: () => {
      if (!isEdit) {
        window.location.href = route('admin.tax.index')
      }
    },
  })
}
</script>

<template>
  <AppLayout :title="props.tax?.tax_id ? 'Edit Tax' : 'New Tax'">
    <template #header>
      <h2 class="font-semibold text-xl text-gray-800 leading-tight">
        {{ props.readOnly ? 'View Tax' : (props.tax?.tax_id ? 'Edit Tax' : 'Create Tax') }}
      </h2>
    </template>

    <div class="max-w-2xl mx-auto py-10 sm:px-6 lg:px-8">
      <FormSection gridClasses="grid-cols-1" :noGrid="true">
        <template #title>
          <a :href="route('admin.tax.index')">
            <SecondaryButton>Back</SecondaryButton>
          </a>
        </template>

        <template #form>
          <div class="flex flex-col gap-4">
            <div>
              <InputLabel value="Name" />
              <TextInput v-model="form.tax_name" class="w-full mt-1" :disabled="props.readOnly" />
            </div>

            <div>
              <InputLabel value="Amount" />
              <TextInput v-model="form.tax_amount" class="w-full mt-1" type="number" step="0.01" :disabled="props.readOnly" />
            </div>

            <div>
              <InputLabel value="Status" />
              <SelectInput v-model="form.status" :disabled="props.readOnly" class="mt-1">
                <option :value="1">Enable</option>
                <option :value="0">Disable</option>
              </SelectInput>
            </div>
          </div>
        </template>

        <template #actions>
          <PrimaryButton v-if="!props.readOnly" @click.prevent="saveForm">Save</PrimaryButton>
        </template>
      </FormSection>
    </div>
  </AppLayout>
</template>
